export default {
  data() {
    return {
      actions: [
        {
          label: 'Refresh Cache (Admin)',
          name: 'refresh_cache_admin',
        },
        {
          label: 'Refresh Cache',
          name: 'refresh_cache',
        },
        {
          label: 'Refresh Profiles',
          name: 'refresh_profiles',
        },
        {
          label: 'Refresh Networks',
          name: 'refresh_networks',
        },
        {
          label: 'Refresh Feeds',
          name: 'refresh_feeds',
        },
        {
          label: 'Refresh FeedRules',
          name: 'refresh_feedRules',
        },
        {
          label: 'Refresh Lists',
          name: 'refresh_lists',
        },
        {
          label: 'Refresh Tags',
          name: 'refresh_tags',
        },
        {
          label: 'Refresh WikipediaPages',
          name: 'refresh_wikipediaPages',
        },
      ],
    };
  },
};
